import React, { createContext, useContext } from "react";
import { useCalculatorData, type CalculatorSnapshot, type UseCalculatorDataParams } from "./hooks/useCalculatorData";

type CalculatorContextValue = ReturnType<typeof useCalculatorData>;

const CalculatorContext = createContext<CalculatorContextValue | null>(null);

export function useCalculatorContext(): CalculatorContextValue {
  const value = useContext(CalculatorContext);
  if (!value) {
    throw new Error("useCalculatorContext must be used within DetailsCalculatorProvider");
  }
  return value;
}

export interface DetailsCalculatorProviderProps extends UseCalculatorDataParams {
  children: React.ReactNode;
}

export function DetailsCalculatorProvider({ children, ...params }: DetailsCalculatorProviderProps) {
  const calculator = useCalculatorData(params);
  return <CalculatorContext.Provider value={calculator}>{children}</CalculatorContext.Provider>;
}

export type { CalculatorSnapshot };
